import { messages as creditsBannerMessages } from '../internal/credits-banner-content/messages';

// Temporary English-only fallback until Traduki publishes the generated Rovo Credits package.
// Do not copy this for other locales; generated Traduki bundles should supply translations.
const temporaryEnglishMessages: Record<string, string> = Object.values(
	creditsBannerMessages,
).reduce<Record<string, string>>((acc, message) => {
	const { defaultMessage, id } = message;

	if (typeof id === 'string' && typeof defaultMessage === 'string') {
		acc[id] = defaultMessage;
	}
	return acc;
}, {});

export default temporaryEnglishMessages;
